var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.50008C0.75 6.50008 3.5225 0.955078 8.37438 0.955078C13.2263 0.955078 15.9988 6.50008 15.9988 6.50008C15.9988 6.50008 13.2263 12.0451 8.37438 12.0451C3.5225 12.0451 0.75 6.50008 0.75 6.50008Z",
    stroke: "#141619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1466 6.50004C11.1466 7.04839 10.984 7.58442 10.6793 8.04036C10.3747 8.49629 9.94166 8.85165 9.43505 9.0615C8.92845 9.27134 8.37099 9.32624 7.83318 9.21927C7.29536 9.11229 6.80135 8.84823 6.41361 8.46049C6.02587 8.07275 5.76181 7.57874 5.65484 7.04093C5.54786 6.50311 5.60276 5.94566 5.81261 5.43905C6.02245 4.93244 6.37781 4.49944 6.83375 4.19479C7.28968 3.89014 7.82572 3.72754 8.37406 3.72754C9.10938 3.72754 9.81457 4.01964 10.3345 4.53959C10.8545 5.05953 11.1466 5.76473 11.1466 6.50004Z",
    stroke: "#141619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.2078fb551544e84c103af516d2d28acb.svg";
export { ForwardRef as ReactComponent };